<template>
    <div class="layout-video" :class="videoClasses">
        <div class="flex flex-1 flex-col space-y-3">
            <div v-if="heading || excerpt" class="flex flex-1 flex-col space-y-2 pb-3">
                <content-subheading v-if="heading" :heading="heading" headingComponent="h2"></content-subheading>
                <content-text v-if="excerpt" :html="excerpt"></content-text>
            </div>
            <embed-tiktok v-if="video && platform === 'tiktok'" :channel="channel" :video="video"></embed-tiktok>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LayoutVideo',
    props: {
        platform: {
            required: false,
            type: String,
            default: null,
        },
        channel: {
            required: false,
            type: String,
            default: null,
        },
        video: {
            required: false,
            type: String,
            default: null,
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        excerpt: {
            required: false,
            type: String,
            default: null,
        },
    },
    computed: {
        videoClasses() {
            const cls = {};
            cls['col-span-1 flex flex-col divide-y divide-gray-200 overflow-hidden bg-white'] = true;
            return cls;
        },
    },
};
</script>
